export const DEBUG=false

export const API_URL="https://api.kehila.syn-assist.fr/v1"
export const ASSET_URL="https://api.kehila.syn-assist.fr/medias/"
export const WEB_BASE_URL="https://kehila.io"

export const CONTENT_API_URL="https://contents.kehila.syn-assist.fr"
